export const categoryFilter = () => {
    const wooFilters = document.querySelectorAll('.woo-filter');
    const maxItems = 5;

    wooFilters.forEach((wooFilter) => {
        const filterItems = wooFilter.querySelectorAll('.woocommerce-widget-layered-nav-list__item');

        if (filterItems.length <= maxItems) {
            return;
        }

        for (let i = 0; i < filterItems.length; i++) {
            if (i >= maxItems) {
                filterItems[i].style.display = 'none';
            }
        }

        const showMoreLink = wooFilter.querySelector('.show-more-link');
        const showLessLink = wooFilter.querySelector('.show-less-link');

        if (showMoreLink) {
            showMoreLink.addEventListener('click', function (event) {
                event.preventDefault();
                for (let i = maxItems; i < filterItems.length; i++) {
                    filterItems[i].style.display = 'list-item';
                }

                showMoreLink.style.display = 'none';
                showLessLink.style.display = 'inline';
            });
        }

        if (showLessLink) {
            showLessLink.addEventListener('click', function (event) {
                event.preventDefault();

                for (let i = maxItems; i < filterItems.length; i++) {
                    filterItems[i].style.display = 'none';
                }

                showLessLink.style.display = 'none';
                showMoreLink.style.display = 'inline';
            });
        }
    });

    const filterContainer = document.querySelector('.filter-container');
    const productFilter = document.querySelector('.product-filter');

    if (filterContainer) {
        filterContainer.addEventListener('click', function() {
            productFilter.classList.toggle('d-none');
        });
    }
};
